import { addRatEvent, RatCpEventCategory, RatCpEventName } from './ratClickEvents';

interface DebouncedEvent {
    category: RatCpEventCategory;
    eventNameKey: string;
    extraData?: object;
    lastFired: number;
}

const debouncedEvents = new Map<string, DebouncedEvent>();
const DEBOUNCE_DELAY = 3000; // 3 seconds

export function addDebouncedRatEvent<C extends RatCpEventCategory>(
    category: C,
    eventNameKey: RatCpEventName<C>,
    extraData: object = {},
    debounceKey?: string,
) {
    const key = debounceKey || `${category}_${String(eventNameKey)}`;
    const now = Date.now();
    const lastEvent = debouncedEvents.get(key);

    if (!lastEvent || now - lastEvent.lastFired > DEBOUNCE_DELAY) {
        addRatEvent(category, eventNameKey, extraData);
        debouncedEvents.set(key, {
            category,
            eventNameKey: String(eventNameKey),
            extraData,
            lastFired: now,
        });
    }
}

export function clearDebouncedEvent(debounceKey: string) {
    debouncedEvents.delete(debounceKey);
}
